module.exports = __webpack_public_path__ + "img/box-patagr.161584b9.png";